import LoanDocuments from './loan-documents';

export default LoanDocuments;
